import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';

interface FloatingAssetProps {
  src: string;
  alt?: string;
  size?: number;
  className?: string;
  floatDuration?: number;
  floatRange?: number;
  rotateDuration?: number;
}

const FloatingAsset = ({
  src,
  alt = '',
  size = 120,
  className = '',
  floatDuration = 6,
  floatRange = 15,
  rotateDuration = 20,
}: FloatingAssetProps) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const y = useTransform(scrollYProgress, [0, 1], [30, -30]);
  const rotate = useTransform(scrollYProgress, [0, 1], [0, 15]);

  return (
    <motion.div
      ref={ref}
      className={`absolute pointer-events-none ${className}`}
      style={{ y, rotate }}
    >
      <motion.img
        src={src}
        alt={alt}
        width={size}
        height={size}
        className="object-contain drop-shadow-lg"
        style={{ width: size, height: size }}
        loading="lazy"
        animate={{
          y: [0, -floatRange, 0],
          rotate: [0, 5, -5, 0],
        }}
        transition={{
          y: { duration: floatDuration, repeat: Infinity, ease: 'easeInOut' },
          rotate: { duration: rotateDuration, repeat: Infinity, ease: 'easeInOut' },
        }}
      />
    </motion.div>
  );
};

export default FloatingAsset;
